<div class="stepper">
  <nz-steps [nzCurrent]="stepper">
    <nz-step nzTitle="Select Data Source"></nz-step>
    <nz-step [nzTitle]="selectedDatasource?.connectionDetailsText || 'Connection Details'"></nz-step>
    <nz-step nzTitle="Column Mapping"></nz-step>
  </nz-steps>
</div>
